const getAddress = (parts) => {
    const result = parts.filter(p => p.types.includes("street_number") || p.types.includes("route")).map(a => a.long_name).join(" ");
    return result || ""
}


const getType = (parts, desiredType, desiredField) => {
    const part = parts.find(p => p.types.find(t => t === desiredType))
    // handle when a field can't be found
    if (part) return part[desiredField] || ""
   else return part || ""
}

// For NYC Boroughs, for example, we sometimes do not have the city name and
// instead use the borough name. This code handles that case
const getCity = (parts) => {
    let locality = getType(parts, "locality", "long_name")
    let sublocality = getType(parts, "sublocality", "long_name")
    let neighborhood = getType(parts, "neighborhood", "long_name")

    const result =  locality || sublocality || neighborhood || ""
    return result
}

const fillInAddress = (addressComponents) => {
    return {
        address: getAddress(addressComponents),
        city: getCity(addressComponents),
        state: getType(addressComponents, "administrative_area_level_1", "short_name"),
        zip: getType(addressComponents, "postal_code", "long_name")
    }
}

export { fillInAddress };
